import React from 'react';
import { Form } from 'react-bootstrap';
import { isNumericFieldType } from './configurationAdminUtils';

// Pump rows retain their fixed defaults for context. Other sections continue
// to use the preview model's normal hiding behavior.
export default function PumpPreviewValue({ field, children }) {
  const disabledValue = field.selectedValue && field.isSelectedValueDisabled;
  if (disabledValue) {
    const value = isNumericFieldType(field.fieldType)
      ? field.performance?.inputValue ?? field.inputValue ?? field.selectedValue.optionValue
      : field.selectedValue.label ?? field.selectedValue.optionValue;
    return <Form.Control aria-label={field.fieldName} value={value ?? ''} readOnly disabled />;
  }
  return field.isHidden ? null : children;
}
